import * as React from 'react'

export const BlankSlate = () => <div className="ViolationHistoryAvailability">

No data available.
</div>


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryList/BlankSlate.tsx